import cn from 'classnames'

import { useRouter } from 'next/router'

import { NetworkLabel } from '../../../../components/ui/network-label'

import ButtonBlue from '../../../../components/ui/button/_color/_blue'

import { useAppSelector } from '../../../../store/hooks'

import { selectedAuthStatus, LoginStatuses } from '../../../../store/reducers/users'

import styles from './styles.module.scss'
import Coin1Icon from './icons/coin1.svg'
import Coin2Icon from './icons/coin2.svg'
import ScrollDotsIcon from './icons/scrollDots.svg'
import SuccessIcon from './icons/success.svg'
import { IExchangeBuyItemProps } from './exchange-buy-item.props'
import { useTranslation } from 'utils/use-translation'

export default function ExchangeBuyItem({ secondCurrency, isGray, firstCurrency }: IExchangeBuyItemProps) {
  const { t } = useTranslation()
  
  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  const estimatedExchange = {
    fromCurrency: firstCurrency.code,
    fromNetwork: firstCurrency.network,
    toCurrency: secondCurrency.code,
    toNetwork: secondCurrency.network,
  }

  const exchange = async () => {
    if (authStatus === LoginStatuses.LOGIN) {
      await router.push({
        pathname: '/account/exchange',
        query: estimatedExchange,
      })
    } else {
      await router.push({
        pathname: '/user/sign-in',
      })
    }
  }
  return (
    <>
      <div className={cn(styles.item, { [styles.item_gray]: isGray })}>
        <div className={styles.item__coin}>
          <div className={styles.pair}>
            <img className={styles.coin1} src={firstCurrency.logo_url} alt="coin 1 icon" />
            <img className={styles.coin2} src={secondCurrency.logo_url} alt="coin 2 icon" />
          </div>

          <div className={styles.content}>
            <div className={styles.content__title}>
              <h5>{secondCurrency.code.toUpperCase()}</h5>
              <NetworkLabel currency={secondCurrency} />
            </div>

            <p>{secondCurrency.name}</p>
          </div>
        </div>

        <div className={styles.item__cell}>
          <p>
            {firstCurrency.code.toUpperCase()} / {secondCurrency.code.toUpperCase()}
          </p>
        </div>

        <div className={styles.item__cell}>
          <img className={styles.success} src={SuccessIcon} alt="Success icon" />
        </div>

        <div className={styles.item__button}>
          <img className={styles.dotsIcon} src={ScrollDotsIcon} alt="scroll dots icon" />
          <ButtonBlue onClick={exchange} className={styles.btn}>
            <span>{t('exchange_btn')}</span> {firstCurrency.code.toUpperCase()} / {secondCurrency.code.toUpperCase()}
          </ButtonBlue>
        </div>
      </div>

      <div className={styles.mobile}>
        <div className={styles.content}>
          <div className={styles.col}>
            <small>{t('btc_to')}</small>
            <small>{t('pair')}</small>
            <small></small>
          </div>

          <div className={styles.col}>
            <div className={styles.coin}>
              <div className={styles.pair}>
                <img className={styles.coin1} src={Coin1Icon} alt="coin 1 icon" />
                <img className={styles.coin2} src={Coin2Icon} alt="coin 2 icon" />
              </div>
              <p>{secondCurrency.code.toUpperCase()}</p>
              <NetworkLabel currency={secondCurrency} />
            </div>
            <p className={styles.data}>
              {firstCurrency.code.toUpperCase()} / {secondCurrency.code.toUpperCase()}
            </p>
            <img className={styles.success} src={SuccessIcon} alt="success icon" />
          </div>
        </div>

        <ButtonBlue onClick={exchange} className={styles.btn__main}>
          {t('exchange_btn')} {firstCurrency.code.toUpperCase()} / {secondCurrency.code.toUpperCase()}
        </ButtonBlue>
      </div>
    </>
  )
}
